"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CALL_FIRESTORE", {
  enumerable: true,
  get: function () {
    return _middleware.CALL_FIRESTORE;
  }
});
Object.defineProperty(exports, "ReactReduxFirebaseProvider", {
  enumerable: true,
  get: function () {
    return _reduxFirebase.ReactReduxFirebaseProvider;
  }
});
Object.defineProperty(exports, "actionTypes", {
  enumerable: true,
  get: function () {
    return _constants.actionTypes;
  }
});
Object.defineProperty(exports, "actions", {
  enumerable: true,
  get: function () {
    return _actions.firestoreActions;
  }
});
Object.defineProperty(exports, "constants", {
  enumerable: true,
  get: function () {
    return _constants.default;
  }
});
Object.defineProperty(exports, "createFirestoreInstance", {
  enumerable: true,
  get: function () {
    return _createFirestoreInstance.default;
  }
});
Object.defineProperty(exports, "createMutate", {
  enumerable: true,
  get: function () {
    return _createMutate.default;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "enhancer", {
  enumerable: true,
  get: function () {
    return _enhancer.default;
  }
});
Object.defineProperty(exports, "firebaseReducer", {
  enumerable: true,
  get: function () {
    return _reduxFirebase.firebaseReducer;
  }
});
Object.defineProperty(exports, "firestoreReducer", {
  enumerable: true,
  get: function () {
    return _reducer.default;
  }
});
Object.defineProperty(exports, "getFirebase", {
  enumerable: true,
  get: function () {
    return _reduxFirebase.getFirebase;
  }
});
Object.defineProperty(exports, "getFirestore", {
  enumerable: true,
  get: function () {
    return _createFirestoreInstance.getFirestore;
  }
});
Object.defineProperty(exports, "getSnapshotByObject", {
  enumerable: true,
  get: function () {
    return _query.getSnapshotByObject;
  }
});
Object.defineProperty(exports, "isLoaded", {
  enumerable: true,
  get: function () {
    return _reduxFirebase.isLoaded;
  }
});
Object.defineProperty(exports, "middleware", {
  enumerable: true,
  get: function () {
    return _middleware.default;
  }
});
Object.defineProperty(exports, "populate", {
  enumerable: true,
  get: function () {
    return _reduxFirebase.populate;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function () {
    return _reducer.default;
  }
});
Object.defineProperty(exports, "reduxFirestore", {
  enumerable: true,
  get: function () {
    return _enhancer.default;
  }
});
Object.defineProperty(exports, "useCache", {
  enumerable: true,
  get: function () {
    return _useCache.default;
  }
});
Object.defineProperty(exports, "useFirebase", {
  enumerable: true,
  get: function () {
    return _reduxFirebase.useFirebase;
  }
});
Object.defineProperty(exports, "useFirestore", {
  enumerable: true,
  get: function () {
    return _reduxFirebase.useFirestore;
  }
});
Object.defineProperty(exports, "useFirestoreConnect", {
  enumerable: true,
  get: function () {
    return _reduxFirebase.useFirestoreConnect;
  }
});
Object.defineProperty(exports, "useRead", {
  enumerable: true,
  get: function () {
    return _useRead.default;
  }
});
exports.version = void 0;

var _reduxFirebase = require("./redux-firebase");

var _enhancer = _interopRequireDefault(require("./enhancer"));

var _reducer = _interopRequireDefault(require("./reducer"));

var _actions = require("./actions");

var _createFirestoreInstance = _interopRequireWildcard(require("./createFirestoreInstance"));

var _constants = _interopRequireWildcard(require("./constants"));

var _middleware = _interopRequireWildcard(require("./middleware"));

var _query = require("./utils/query");

var _createMutate = _interopRequireDefault(require("./utils/createMutate"));

var _useRead = _interopRequireDefault(require("./hooks/useRead"));

var _useCache = _interopRequireDefault(require("./hooks/useCache"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const version = "0.0.7-alpha.8";
exports.version = version;
var _default = {
  version,
  reducer: _reducer.default,
  firestoreReducer: _reducer.default,
  firebaseReducer: _reduxFirebase.firebaseReducer,
  enhancer: _enhancer.default,
  useRead: _useRead.default,
  useCache: _useCache.default,
  getFirebase: _reduxFirebase.getFirebase,
  useFirestore: _reduxFirebase.useFirestore,
  useFirebase: _reduxFirebase.useFirebase,
  ReactReduxFirebaseProvider: _reduxFirebase.ReactReduxFirebaseProvider,
  reduxFirestore: _enhancer.default,
  createFirestoreInstance: _createFirestoreInstance.default,
  actions: _actions.firestoreActions,
  getFirestore: _createFirestoreInstance.getFirestore,
  getSnapshotByObject: _query.getSnapshotByObject,
  constants: _constants.default,
  actionTypes: _constants.actionTypes,
  middleware: _middleware.default,
  CALL_FIRESTORE: _middleware.CALL_FIRESTORE,
  createMutate: _createMutate.default,
  useFirestoreConnect: _reduxFirebase.useFirestoreConnect,
  populate: _reduxFirebase.populate,
  isLoaded: _reduxFirebase.isLoaded
};
exports.default = _default;